// Sectors for Selena Matrix configurator
export const SECTORS = [
  {
    id: "hotel",
    name: "Hôtellerie & Voyages",
    nameEn: "Hospitality & Travel",
    pack: ["jade", "selena", "atlas", "clara", "lena"],
    pitch: "Réservations fluides, fidélisation forte, présence sociale soignée.",
    pitchEn: "Smooth bookings, stronger loyalty, polished social presence.",
    monthly_revenue_base_php: 280000, // baseline starting revenue at month 1
    growth_rate: 0.18, // 18% per month
    icon: "Plane",
  },
  {
    id: "pme",
    name: "PME / Services",
    nameEn: "SMB / Services",
    pack: ["aria", "selena", "atlas", "clara"],
    pitch: "Acquisition continue, suivi client premium, décisions guidées par la donnée.",
    pitchEn: "Continuous acquisition, premium support, data-led decisions.",
    monthly_revenue_base_php: 220000,
    growth_rate: 0.15,
    icon: "Briefcase",
  },
  {
    id: "ecommerce",
    name: "E-commerce",
    nameEn: "E-commerce",
    pack: ["aria", "athena", "atlas", "clara", "vega"],
    pitch: "Conversion en hausse, paniers plus pleins, créatifs en flux continu.",
    pitchEn: "Higher conversion, fuller carts, non-stop creative output.",
    monthly_revenue_base_php: 350000,
    growth_rate: 0.22,
    icon: "ShoppingCart",
  },
  {
    id: "agence",
    name: "Agence / Cabinet",
    nameEn: "Agency / Consulting",
    pack: ["aria", "selena", "vega", "athena"],
    pitch: "Production créative démultipliée, livrables sécurisés, marges préservées.",
    pitchEn: "Amplified creative output, secured deliverables, protected margins.",
    monthly_revenue_base_php: 320000,
    growth_rate: 0.16,
    icon: "Briefcase",
  },
  {
    id: "saas",
    name: "SaaS / Tech",
    nameEn: "SaaS / Tech",
    pack: ["neo", "athena", "atlas", "clara", "sofia"],
    pitch: "MRR en croissance, churn maîtrisé, support 24/7 sans douleur.",
    pitchEn: "Growing MRR, controlled churn, painless 24/7 support.",
    monthly_revenue_base_php: 420000,
    growth_rate: 0.25,
    icon: "Cpu",
  },
  {
    id: "education",
    name: "Éducation / Formation",
    nameEn: "Education / Training",
    pack: ["athena", "vega", "clara", "sofia"],
    pitch: "Inscription fluide, contenu engageant, suivi élève irréprochable.",
    pitchEn: "Smooth enrolment, engaging content, faultless student tracking.",
    monthly_revenue_base_php: 180000,
    growth_rate: 0.12,
    icon: "GraduationCap",
  },
  {
    id: "immobilier",
    name: "Immobilier",
    nameEn: "Real Estate",
    pack: ["atlas", "lexa", "aria", "athena"],
    pitch: "Mandats optimises, clients qualifies, transactions accelerees.",
    pitchEn: "Optimised mandates, qualified leads, faster transactions.",
    monthly_revenue_base_php: 380000,
    growth_rate: 0.17,
    icon: "Home",
  },
  {
    id: "juridique",
    name: "Cabinet Avocat / Notaire",
    nameEn: "Law / Notary Firm",
    pack: ["lexa", "aria", "athena", "atlas"],
    pitch: "Conformite assuree, dossiers traites vite, clients rassures.",
    pitchEn: "Compliance assured, fast case processing, reassured clients.",
    monthly_revenue_base_php: 290000,
    growth_rate: 0.13,
    icon: "Scale",
  },
  {
    id: "banque",
    name: "Banque / Finance",
    nameEn: "Banking / Finance",
    pack: ["aria", "lexa", "athena", "atlas"],
    pitch: "Flux securises, reporting automatise, conformite totale.",
    pitchEn: "Secured flows, automated reporting, full compliance.",
    monthly_revenue_base_php: 450000,
    growth_rate: 0.19,
    icon: "Landmark",
  },
  {
    id: "sante",
    name: "Sante / Medical",
    nameEn: "Health / Medical",
    pack: ["clara", "lexa", "sofia", "athena"],
    pitch: "Patients mieux suivis, agenda optimise, conformite garantie.",
    pitchEn: "Better patient follow-up, optimised agenda, guaranteed compliance.",
    monthly_revenue_base_php: 260000,
    growth_rate: 0.14,
    icon: "Heart",
  },
  {
    id: "restaurant",
    name: "Restaurant / Food",
    nameEn: "Restaurant / Food",
    pack: ["clara", "atlas", "lena", "aria"],
    pitch: "Reservations automatisees, fidelite client, gestion simplifiee.",
    pitchEn: "Automated reservations, customer loyalty, simplified management.",
    monthly_revenue_base_php: 160000,
    growth_rate: 0.11,
    icon: "UtensilsCrossed",
  },
  {
    id: "administration",
    name: "Administration",
    nameEn: "Administration",
    pack: ["lexa", "aria", "clara", "neo"],
    pitch: "Demarches simplifiees, conformite assuree, delais respectes.",
    pitchEn: "Simplified procedures, ensured compliance, respected deadlines.",
    monthly_revenue_base_php: 140000,
    growth_rate: 0.09,
    icon: "FileText",
  },
  {
    id: "medias",
    name: "Medias / Contenu",
    nameEn: "Media / Content",
    pack: ["vega", "lena", "athena", "selena"],
    pitch: "Contenu produit en masse, audience engagee, monetisation acceleree.",
    pitchEn: "Mass content production, engaged audience, accelerated monetisation.",
    monthly_revenue_base_php: 200000,
    growth_rate: 0.20,
    icon: "Tv",
  },
  {
    id: "influenceurs",
    name: "Influenceurs / Createurs",
    nameEn: "Influencers / Creators",
    pack: ["lena", "vega", "athena", "selena"],
    pitch: "Contenu viral, communaute active, revenus diversifies en automatique.",
    pitchEn: "Viral content, active community, diversified revenue on autopilot.",
    monthly_revenue_base_php: 180000,
    growth_rate: 0.28,
    icon: "Star",
  },
  {
    id: "social_auto",
    name: "Automation Reseaux Sociaux",
    nameEn: "Social Media Automation",
    pack: ["lena", "vega", "athena", "selena"],
    pitch: "Publiez, engagez et monetisez vos reseaux en pilote automatique.",
    pitchEn: "Publish, engage and monetise your networks on autopilot.",
    monthly_revenue_base_php: 160000,
    growth_rate: 0.30,
    icon: "Share2",
  },
  {
    id: "coachs",
    name: "Coachs / Consultants",
    nameEn: "Coaches / Consultants",
    pack: ["selena", "athena", "aria", "clara"],
    pitch: "Clients accompagnes mieux, agenda plein, facturation automatisee.",
    pitchEn: "Better client support, full agenda, automated billing.",
    monthly_revenue_base_php: 210000,
    growth_rate: 0.18,
    icon: "Users",
  },
  {
    id: "bienetre",
    name: "Therapeutes / Bien-etre",
    nameEn: "Therapists / Wellness",
    pack: ["clara", "sofia", "lexa", "athena"],
    pitch: "Suivi patient personnalise, agenda sans friction, conformite RGPD.",
    pitchEn: "Personalised patient follow-up, frictionless agenda, GDPR compliance.",
    monthly_revenue_base_php: 150000,
    growth_rate: 0.13,
    icon: "Smile",
  },
  {
    id: "artistes",
    name: "Artistes / Musiciens",
    nameEn: "Artists / Musicians",
    pack: ["vega", "lena", "athena", "selena"],
    pitch: "Visibilite amplifiee, droits proteges, revenus recurrents.",
    pitchEn: "Amplified visibility, protected rights, recurring revenue.",
    monthly_revenue_base_php: 130000,
    growth_rate: 0.16,
    icon: "Music",
  },
  {
    id: "photo",
    name: "Photographes / Videastes",
    nameEn: "Photographers / Videographers",
    pack: ["vega", "lena", "atlas", "athena"],
    pitch: "Portfolio visible, clients qualifies, livrables automatises.",
    pitchEn: "Visible portfolio, qualified clients, automated deliverables.",
    monthly_revenue_base_php: 140000,
    growth_rate: 0.14,
    icon: "Camera",
  },
  {
    id: "esport",
    name: "E-sport / Gaming",
    nameEn: "E-sport / Gaming",
    pack: ["neo", "vega", "atlas", "lena"],
    pitch: "Communaute engagee, streams optimises, sponsors attires.",
    pitchEn: "Engaged community, optimised streams, sponsors attracted.",
    monthly_revenue_base_php: 190000,
    growth_rate: 0.25,
    icon: "Gamepad2",
  },
  {
    id: "freelance",
    name: "Freelance / Solo",
    nameEn: "Freelance / Solo",
    pack: ["selena", "aria", "athena", "neo"],
    pitch: "Clients trouves, missions gerees, paiements automatises.",
    pitchEn: "Clients found, missions managed, automated payments.",
    monthly_revenue_base_php: 120000,
    growth_rate: 0.20,
    icon: "Zap",
  },
];
